:host {
  display: flex;
  position: relative;
  flex-direction: column;
  inline-size: 100%;

  --ch-grid-cell-active-layer: calc(var(--ch-grid-base-layer) * 1);
  --ch-grid-column-header-layer: calc(var(--ch-grid-base-layer) * 2);
  --ch-grid-column-freeze-layer: calc(var(--ch-grid-base-layer) * 4);
  --ch-grid-column-active-layer: calc(var(--ch-grid-base-layer) * 8);
  --ch-grid-settings-layer: calc(var(--ch-grid-base-layer) * 16);
}
.main {
  display: none;
  grid-auto-flow: dense; /* necesario para poder reordenar las columnas */
  grid-auto-rows: max-content;
  overflow-x: auto;
  user-select: none;
  block-size: 100%;
}
